var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[(_vm._isMobile())?_c('div',{staticClass:"wap-content"},[_vm._v(" 请在电脑端操作本功能 ")]):_c('div',{staticClass:"web-content"},[_vm._v(" 菜单有误请联系技术人员 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }